<ion-header mode="ios">
    <ion-toolbar>
        <ion-title>qid</ion-title>

        <button sxCircle="42px" sxMargin="0 10px" sxBackground="#212121" sxCenterize="col" slot="start"
            (click)="back()">
            <ion-icon sxTextSize="28px" name="close-outline" sxColor="white"></ion-icon>
        </button>

        @if (isNativePlatform() && !disableDownload) {
        <button sxCircle="36px" sxMargin="0 10px" sxCenterize="col" slot="end" (click)="shareImage()">
            <ion-icon sxTextSize="28px" name="share-outline" sxColor="white"></ion-icon>
        </button>
        } @else if (!disableDownload) {
        <button sxCircle="36px" sxMargin="0 10px" sxCenterize="col" slot="end" (click)="shareToLocal()">
            <ion-icon sxTextSize="28px" name="download-outline" sxColor="white"></ion-icon>
        </button>
        }
    </ion-toolbar>
</ion-header>
<ion-content (contextmenu)="preventContextMenu($event)" (mousedown)="preventRightClick($event)">
    <div sxCol sxDistribution="spaceBetween" sxWidth="full" sxHeight="full" sxAlign="center" sxBackground="black"
        (contextmenu)="preventContextMenu($event)" (mousedown)="preventRightClick($event)">



        @switch (zoomType) {
        @case ('pinch') {
        <div #imageContainer class="image-container">
            @if (imageUrlArray && imageUrlArray.length > 0) {
            @for (imageUrl of imageUrlArray; track $index) {
            @if (isCurrentImage($index)) {
            <pinch-zoom>
                <img [src]="getUrl(imageUrl)" [alt]="'Image ' + ($index + 1)" draggable="false"
                    (error)="onImageError($event)" (load)="onImageLoad($event)" (contextmenu)="preventContextMenu($event)">
            </pinch-zoom>
            }
            }
            } @else if (imageUrl) {
            <pinch-zoom>
                <img [src]="getUrl()" [alt]="'Image'" draggable="false" (error)="onImageError($event)"
                    (load)="onImageLoad($event)" (contextmenu)="preventContextMenu($event)">
            </pinch-zoom>
            }
        </div>
        }
        @case ('mouse') {
        <div class="image-container" (mousemove)="zoomImage($event)" (mouseleave)="onFocusOut()">
            <img #mainImage id="main-image" [src]="getUrl()" alt="Product Image" (contextmenu)="preventContextMenu($event)">
            <div #zoomResult id="zoom-result"></div>
        </div>
        }
        }



        @if (imageUrlArray.length > 1) {
        <div class="thumbnail-container">
            <div class="thumbnail-wrapper">
                @for (imageUrl of imageUrlArray; track $index) {
                <div class="thumbnail-item" [class.active]="isCurrentImage($index)" (click)="navigateToImage($index)">
                    <div class="thumbnail-image" [style.backgroundImage]="'url(' + getUrl(imageUrl) + ')'"></div>
                </div>
                }
            </div>
        </div>
        }
    </div>
</ion-content>